import "./App.css";

export default function App() {
  return (
    <div className="site">
      <section className="hero">
        <div className="hero-inner">
          <div className="wordmark-col">
            <span className="accent-bar" />
            <h1 className="wordmark">EVO</h1>
          </div>
          <div className="hero-meta">
            <a href="mailto:hello@evocollectibles.io" className="email-link">
              <span className="email-dot" />
              Email
            </a>
            <p className="hero-sub">
              Building the Future of
              <br />
              Collectibles Tech
            </p>
          </div>
        </div>
      </section>

      <section className="page-section" id="company">
        <div className="section-bar">
          <span className="section-num">(1)</span>
          <span className="section-label">COMPANY</span>
          <span className="section-fill">EST. 2026</span>
          <span className="section-end">EVO COLLECTIBLES INC.</span>
        </div>
        <div className="section-body">
          <h2 className="section-heading">
            Building the future of collectibles tech.
          </h2>
          <p className="section-copy">
            We believe the collectibles market deserves modern software. From
            AI-powered grading to real-time market intelligence, we're building
            the tools that collectors have always needed.
          </p>
        </div>
      </section>

      <section className="page-section" id="product">
        <div className="section-bar">
          <span className="section-num">(2)</span>
          <span className="section-label">PRODUCT</span>
          <span className="section-fill" />
          <span className="section-end">FLAGSHIP</span>
        </div>
        <div className="section-body">
          <h2 className="section-heading">
            Evo - The future of card collecting.
          </h2>
          <p className="section-copy">
            Evo is our flagship mobile app, pioneering AI grading for
            collectible cards. Using advanced computer vision, Evo analyzes card
            condition with precision with our proprietary models instantly, from
            your phone.
          </p>
          <p className="section-copy">
            Beyond grading, Evo surfaces arbitrage opportunities across the
            market, helping collectors identify undervalued cards and make
            smarter buying decisions. Combined with a suite of quality-of-life
            tools like collection management, price tracking, and wish lists.
          </p>
        </div>
      </section>

      <section className="page-section" id="team">
        <div className="section-bar">
          <span className="section-num">(3)</span>
          <span className="section-label">TEAM</span>
          <span className="section-fill" />
          <span className="section-end">CONTACT</span>
        </div>
        <div className="section-body">
          <h2 className="section-heading">A small team. A sharp focus.</h2>
          <p className="section-copy">
            We're a small team focused on shipping quality products.
          </p>
          <p className="section-copy">
            Reach us at{" "}
            <a href="mailto:hello@evocollectibles.io" className="inline-link">
              hello@evocollectibles.io
            </a>
          </p>
        </div>
      </section>

      <footer className="site-footer">
        <span>Evo Collectibles Inc.</span>
        <span>© {new Date().getFullYear()}</span>
      </footer>
    </div>
  );
}
